import React from "react"
import { useFormSubmissionAuditTrailContext } from "contexts/FormSubmissionAuditTrailContext"
import { Checkbox } from "shared/checkboxes"

const ShowResolutionAuditsCheckbox = () => {
  const {
    resolutionAuditsShown,
    showResolutionAudits,
    hideResolutionAudits,
  } = useFormSubmissionAuditTrailContext()

  const checkboxId = "resolution-checkbox-filter"

  return (
    <div
      className="mb-2 rounded-md cursor-pointer p-2 border border-lightgray-3
                 text-sm font-medium w-full flex items-center justify-between input-focus-ring"
      onClickCapture={resolutionAuditsShown ? hideResolutionAudits : showResolutionAudits}
    >
      <label
        className="screenreader-only"
        htmlFor={checkboxId}
      >Show resolution audit items
      </label>

      <span className="flex-grow mr-4" aria-hidden>Resolution</span>
      <Checkbox value={resolutionAuditsShown} uuid={checkboxId} />
    </div>
  )
}

export default ShowResolutionAuditsCheckbox
